import React from 'react';

const PhotoUp = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M30 16H30.02M25 42H12C10.4087 42 8.88258 41.3679 7.75736 40.2426C6.63214 39.1174 6 37.5913 6 36V12C6 10.4087 6.63214 8.88258 7.75736 7.75736C8.88258 6.63214 10.4087 6 12 6H36C37.5913 6 39.1174 6.63214 40.2426 7.75736C41.3679 8.88258 42 10.4087 42 12V25M6 32L16 22C17.856 20.214 20.144 20.214 22 22L29 29M28 28L30 26C31.358 24.694 32.946 24.342 34.428 24.948M38 44V32M38 32L44 38M38 32L32 38",
      stroke: "white",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
PhotoUp.displayName = "Icons.PhotoUp";

export { PhotoUp };
//# sourceMappingURL=PhotoUp.js.map
